import React, { useEffect } from 'react';
import withView from '../../../cmn/docAutomation/withView';
import { UiView, UiViewContent } from '../../../../library/layout/Index';

const DocGridYAxisRow = (props)=>{
    const {formObject, viewData, viewRow, rowKey, rowID, reloadSearch} = props

    const renderYAxisView = () => {
        let DynamicComponent = formObject.viewMap[viewRow.viewKey];

        if(!DynamicComponent)
        {
            DynamicComponent = formObject.viewMap["vCMNGridLabel"];
        }

        if(!DynamicComponent)
        {
            return null;
        }
        else
        {
            return <DynamicComponent formObject={formObject} viewData={viewData} rowKey={rowKey} 
            rowID={rowID} reloadSearch={reloadSearch}/>
        }
    }

    // console.log("viewData.rowValues", viewData.rowValues);

    return(
        <div>{renderYAxisView()}</div>
    )
}

const DocGridYAxisData = (props)=>{
    const {formObject, viewData, reloadSearch, xGridSize, sidebarScroll, onSidebarScroll} = props

    const initialiseActions = () => {
        // console.log("custom action set", formObject.dataList);
        if(formObject.dataList) {
            formObject.initialiseCustomActions(formObject.dataList.actionName, 
                formObject.dataList.depActions);
        }
    }

    useEffect(initialiseActions, [props.viewData]);
    
    if(viewData){
        return(
            <UiView>
                <UiViewContent>
                    <ul className="uiListContainer uiListScroll sidebar-scroll" style={{height:`${(xGridSize && xGridSize.height)}px`}} 
                        id="sidebar-scroll"
                        ref={sidebarScroll}
                        onScroll={onSidebarScroll}>
                        {
                            Object.values(viewData).map((row, index)=>(
                                <li key={index} className="uiListRow uiActionIndicator">
                                    <DocGridYAxisRow formObject={formObject} viewData={viewData} viewRow={row} 
                                        rowKey={row.rowKey} rowID={row.dataList.dbRowId} 
                                        reloadSearch={reloadSearch}></DocGridYAxisRow>
                                </li>
                            ))
                        }
                    </ul>
                </UiViewContent>
            </UiView>
        )
    }
    else return null;
}

export default withView(DocGridYAxisData, '', '', 0);
